// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mcs-module{outline:none}.mcs-module .current-location{color:#046;font-size:14px;text-decoration:none;border-bottom:1px dashed #046}", ""]);
// Exports
module.exports = exports;
